
import { useState, useEffect } from 'react';
import { Button, Row, Col, Form} from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import { getCategories } from '../../services/Configs/ItemCategoriesService';
import { getSubCategory, updateSubCategory } from '../../services/Configs/ItemSubCategoriesService';
 
function EditItemSubCategoryModal({ subcategoryId, show, handleClose, handleReload }) {
  const [categories, setCategories] = useState([]);
  const [formData, setFormData] = useState({
    id: subcategoryId,
    name: '',
    isActive: false,
    categoryId: 0
  })  
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  

  const handleUpdateSubCategory = () => {
    let pendingInputs = [];
    if(!formData.name)
    {
        pendingInputs.push("Categoría")
    }
    if(pendingInputs.length == 0)
    {
      updateSubCategory(formData.id, formData.categoryId, formData.name, formData.isActive).then(locationResult => {
        toast.success('Subcategoría actualizada correctamente');
        handleClose();
        handleReload();
        });
    }
    else
    {
        toast.warning(`Lo sentimos, debes completar los siguientes campos: ${pendingInputs.join(', ')}`)
    }
  }
  useEffect(() => {
    if (show) {
      getSubCategory(subcategoryId).then(obj => {
        console.log(obj)    
        setFormData({
                id: obj.id,
                name: obj.name,
                isActive: obj.isActive,
                categoryId: obj.categoryId
            });
        });
        getCategories().then(list => {
          setCategories(list);
        })
    }
  }, [show, subcategoryId]);
  return (
    <Modal size="sm" show={show} onHide={handleClose} backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>Actualizar  Subcategoría</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row className='mt-2'>
              <Col xl={12} className=' p-2'  >
                <Form.Label>Nombre:</Form.Label>
                          <Form.Group controlId="">
                          <Form.Control
                              type="text"
                              name="name"
                              placeholder='Nombre de la categoría'
                              value={formData.name}
                              onChange={handleInputChange}
                          />
                  </Form.Group>
              </Col>
       </Row>
       <Row className='mt-2'>
            <Col xl={12}>
                  <Form.Group controlId="">
                  <Form.Label>Categoría:</Form.Label>
                      <Form.Control
                          as="select"
                          name="categoryId"
                          value={formData.categoryId}
                          onChange={handleInputChange}
                      >
                          {categories.map((category) => (
                                  category.isActive ? 
                                  <option key={category.id} value={category.id}>{category.name}</option> :
                                  null
                          ))}
                      </Form.Control>
                  </Form.Group>
            </Col>
       </Row>
       <Row className='mt-2'>
            <Col xl={12}>
                <Form.Group className='mt-3' controlId="formWorkFromHome">
                    <Form.Label>Estatus:</Form.Label>
                    <Form.Check
                        type="radio"
                        label="Activa"
                        name="isActive"
                        value="true"
                        checked={formData.isActive === true}
                        onChange={() => setFormData({ ...formData, isActive: true })}
                    />
                    <Form.Check
                        type="radio"
                        label="Inactiva"
                        name="isActive"
                        value="false"
                        checked={formData.isActive=== false}
                        onChange={() => setFormData({ ...formData, isActive: false })}
                    />
                </Form.Group>
            </Col>
       </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="success" onClick={handleUpdateSubCategory}>
           Actualizar
        </Button>
        <Button variant="secondary" onClick={handleClose}>
           Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default EditItemSubCategoryModal;
